import React, { useState } from 'react'

import { Box } from '@mui/material'
import PlusCircle32 from '@evocolabs/icons/lib/PlusCircle32'
import PlusCircleFill32 from '@evocolabs/icons/lib/PlusCircleFill32'
import MinusCircleFill32 from '@evocolabs/icons/lib/MinusCircleFill32'
import MinusCircle32 from '@evocolabs/icons/lib/MinusCircle32'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import { Typography, Button } from '@evocolabs/orkaui'
import { useRouter } from 'next/router'
import style from '@/pages/scss/OrkaTwo.module.scss'

const data = [
  {
    id: 'productbuy_fda_registered',
    title: 'Are Orka Two hearing aids FDA-registered?',
    content:
      'Yes. Orka Two hearing aids are FDA-registered Class II 510K exempt medical devices designed for individuals with mild to moderately severe hearing loss. Orka Two is not personal amplification product (PSAPs).'
  },
  {
    id: 'productbuy_who_use',
    title: 'Who should use Orka Two hearing aids?',
    content:
      'Orka Two is designed to serve people with mild to moderately-severe hearing loss. Speak with our Orka specialists today about how we can help you along your hearing journey.'
  },
  {
    id: 'productbuy_apply_refund',
    title: `Can I apply for a refund?`,
    content:
      'Yes. At Orka, we guarantee you a 45-day 100% money-back refund. You can apply for a return and a full refund within 45 days from the day you receive your product. Note: The equipment must be fully intact.'
  }
]
const text = {
  title: 'FAQ',
  more: 'View More'
}

const Add = () => {
  const [hovered, setHovered] = useState(false)
  const handleMouseEnter = () => {
    setHovered(true)
  }
  const handleMouseLeave = () => {
    setHovered(false)
  }
  return (
    <Box onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {hovered ? (
        <PlusCircleFill32 sx={{ color: '#26201F', fontSize: '28px' }} />
      ) : (
        <PlusCircle32 sx={{ color: '#26201F', fontSize: '28px' }} />
      )}
    </Box>
  )
}
const Minus = () => {
  const [hovered, setHovered] = useState(false)
  const handleMouseEnter = () => {
    setHovered(true)
  }
  const handleMouseLeave = () => {
    setHovered(false)
  }
  return (
    <Box onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {hovered ? (
        <MinusCircleFill32 sx={{ color: '#26201F', fontSize: '28px' }} />
      ) : (
        <MinusCircle32 sx={{ color: '#26201F', fontSize: '28px' }} />
      )}
    </Box>
  )
}

const ProductFAQ = function ({ info = data }) {
  const [expanded, setExpanded] = React.useState(false)
  const clickHandler = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }
  const generateId = (i) => `panel${i}`
  const router = useRouter()
  return (
    <Box className={style['product-faq-box']}>
      <Typography
        variant="h2"
        lineHeight="1.3"
        pt="64px"
        display="flex"
        justifyContent="center"
      >
        {text.title}
      </Typography>
      <Box>
        {info.map((item, i) => (
          <Accordion
            id={item.id}
            expanded={expanded === generateId(i)}
            key={i}
            className={style['product-faq-list-item']}
            onChange={clickHandler(generateId(i))}
          >
            <AccordionSummary
              aria-controls={generateId(i) + 'bh-content'}
              id={generateId(i) + 'bh-header'}
              sx={{
                padding: 0,
                minHeight: 'unset !important',
                lineHeight: 0,
                margin: 0,
                '&.Mui-expanded': { marginBottom: '16px !important' },
                '>div': { margin: '0 !important' },
                ' .MuiAccordionSummary-expandIconWrapper': { transform: 'none' }
              }}
              expandIcon={expanded === generateId(i) ? <Minus /> : <Add />}
            >
              <Typography variant="T2" lineHeight="1.5">
                {item.title}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ padding: 0 }}>
              <Typography variant="body2">{item.content}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
      <Box display="flex" alignItems="center" sx={{ cursor: 'pointer' }}>
        <Button
          id="product-view_more_faq"
          variant="textprimary"
          icon
          onClick={() => {
            router.push('/faq')
          }}
        >
          {text.more}
        </Button>
      </Box>
    </Box>
  )
}

export default ProductFAQ
